import React, { useContext } from 'react';
import { getTranslation } from '../utils/config';

import Grid from './grid';
import { useDfContext } from '../context/df-context';
import { REMOVE_FILTER, RESET_FILTERS, SET_FILTER_PARAMS, SET_TERM } from '../context/actions';
import { useFilterlabel } from '../hooks/use-filterlabel';
import { DfCategoriesContext } from '../context/categories/df-categories-context';

export default function ActiveFilters(): React.ReactElement | null {
  const {
    state: { term, params, itemFilter },
    dispatch,
  } = useDfContext();
  const { categories } = useContext(DfCategoriesContext);

  const { langLabel, fileLabel } = useFilterlabel();
  const variantLabel = getTranslation('variant');

  const removeFilter = (id: number) => {
    dispatch({
      type: REMOVE_FILTER,
      id,
    });
  };

  const deleteSearchTerm = () => {
    dispatch({
      type: SET_TERM,
      term: undefined,
    });
  };

  const resetAll = () => {
    dispatch({
      type: RESET_FILTERS,
    });
    dispatch({
      type: SET_TERM,
      term: undefined,
    });
    dispatch({
      type: SET_FILTER_PARAMS,
      filter: {
        language: [],
        fileType: [],
        variants: [],
      },
    });
  };

  const removeFileFilter = (type: string, item: string) => {
    const newFilter = { ...itemFilter };
    newFilter[type] = newFilter[type].filter((v) => v !== item);
    dispatch({
      type: SET_FILTER_PARAMS,
      filter: newFilter,
    });
  };

  if (
    params.length === 0 &&
    !term &&
    (!itemFilter?.variants || itemFilter.variants?.length === 0) &&
    (!itemFilter?.language || itemFilter.language?.length === 0) &&
    (!itemFilter?.fileType || itemFilter.fileType?.length === 0)
  ) {
    return null;
  }

  return (
    <Grid>
      <div className="df-filters">
        {term && (
          <button key={term} className="df-filter-pill__button" onClick={deleteSearchTerm}>
            <span className="df-filter-pill">{term}</span>
          </button>
        )}

        {itemFilter &&
          itemFilter.variants?.length > 0 &&
          itemFilter.variants.map((variant) => (
            <button
              key={`${variantLabel}-${variant}`}
              className="df-filter-pill__button"
              onClick={() => removeFileFilter('variants', variant)}
            >
              <span className="df-filter-pill">
                {variantLabel}: {variant}
              </span>
            </button>
          ))}

        {itemFilter &&
          itemFilter.language?.length > 0 &&
          itemFilter.language.map((fileLang) => (
            <button
              key={`${langLabel}-${fileLang}`}
              className="df-filter-pill__button"
              onClick={() => removeFileFilter('language', fileLang)}
            >
              <span className="df-filter-pill">
                {langLabel}: {fileLang}
              </span>
            </button>
          ))}

        {itemFilter &&
          itemFilter.fileType?.length > 0 &&
          itemFilter.fileType.map((fileType) => (
            <button
              key={`${fileLabel}-${fileType}`}
              className="df-filter-pill__button"
              onClick={() => removeFileFilter('fileType', fileType)}
            >
              <span className="df-filter-pill">
                {fileLabel}: {fileType}
              </span>
            </button>
          ))}
        {params.map((filter) => (
          <button
            key={filter.pimId}
            className="df-filter-pill__button"
            onClick={() => removeFilter(filter.pimId)}
          >
            <span className="df-filter-pill">{categories[filter.pimId]?.displayname}</span>
          </button>
        ))}
        <button className="df-btn df-btn--simple df-btn--reset df-filter-reset" onClick={resetAll}>
          <span>{getTranslation('reset_all_filters')}</span>
        </button>
      </div>
    </Grid>
  );
}
